import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const Videos = () => {
  const homeMenu = [
    { label: "Vision", link: "/about" },
    {
      label: "Management",
      link: "",
      subMenu: [
        { label: "Director's Message", link: "/DirectorMessage" },
        { label: "Principal's Message", link: "/PrincipalMessage" },
        { label: "Leadership Team", link: "/leadershipTeam" },
        { label: "Patron’s Message", link: "/patrons" },
        { label: "Advisory Board", link: "/advisoryBoard" },
      ],
    },

    { label: "International Collaborations", link: "/partnership" },
    // { label: "Awards & Achievements", link: "/awardsAcheivements" },

{
      label: "Awards & Achievements",
      link: "/awardsAcheivements",
      subMenu: [
        { label: "Accolades & Achievements", link: "/awardsAcheivements" },
        { label: "Students Achievements", link: "/studentsAcheivements" },
      ],
    },

    { label: "Faculty", link: "/faculty" },
    { label: "Staff Details", link: "/staffDetails" },
    { label: "School Strength ", link: "/schoolStrength" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-cyber.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Cyber@Lotusमित्र"
                breadEnd="Cyber@Lotusमित्र"
                breadMid="Cyber@Lotusमित्र"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 mb-4">
              <div class="lab-heading mb-4">
                <div class="lab-btn" id="mb-lab-btn">
                  <span>Cyber@Lotusमित्र</span>
                </div>
                <ul class="labs-list">
                  <li>
                    <a class="" href="/CyberSecurity">
                      Activities
                    </a>
                  </li>
                  <li>
                    <a class="inc-tlink-active" href="/Videos">
                      Videos
                    </a>
                  </li>
                  <li>
                    <a class="" href="/StoryBooks">
                      E-Cyber Story Books
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4">
              <iframe
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cybervideo5.mp4"
                width="100%"
                height="300"
              ></iframe>
            </div>
            <div className="col-lg-4">
              <iframe
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cybervideo4.mp4"
                width="100%"
                height="300"
              ></iframe>
            </div>
            <div className="col-lg-4">
              <iframe
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cybervideo.mp4"
                width="100%"
                height="300"
              ></iframe>
            </div>
            <div className="col-lg-4">
              <iframe
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cybervideo1.mp4"
                width="100%"
                height="300"
              ></iframe>
            </div>
            <div className="col-lg-4">
              <iframe
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cybervideo2.mp4"
                width="100%"
                height="300"
              ></iframe>
            </div>
            <div className="col-lg-4">
              <iframe
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cybervideo3.mp4"
                width="100%"
                height="300"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Videos;
